import { render, staticRenderFns } from "./ConfigMemberIcon.vue?vue&type=template&id=74a60f7d"
import script from "./ConfigMemberIcon.vue?vue&type=script&lang=js"
export * from "./ConfigMemberIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports